export default __webpack_public_path__ + "static/media/khatm.6a342f22.jpg";